import React from "react";

import Card from "./card";
import { Row, Col } from "antd";

import { faReact, faDocker } from "@fortawesome/free-brands-svg-icons";
import {
	faGear,
	faCode,
	faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
const Language = (props) => {
	const { user, title, icon } = props;
	return (
		<div>
			<Row>
				<Col className="mb-2" xs={24} sm={24} md={24} lg={24}>
					<Card
						icon={icon}
						title={title}
						body={
							<>
								<div
									className="work"
									style={{
										display: "flex",
										justifyContent: "flex-start",
										gap: "10px",
										alignItems: "center",
									}}
								>
									{user?.map((i) => {
										return (
											<div className="project-logo ">
												<img src={i} alt="logo" />
											</div>
										);
									})}
								</div>
							</>
						}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default Language;
